import * as React from 'react';
import LockIcon from '@material-ui/icons/Lock';
import Typography from '@material-ui/core/Typography';

interface IUnauthorizedProps {
  message?: string;
}

export const Unauthorized = ({ message = 'You are not authorized to access this resource.' }: IUnauthorizedProps) => (
  <Typography align="center" variant="h4">
    <LockIcon />
    {message}
  </Typography>
);
